<template>
    <div class="centered-div">
      <h2>Login</h2>
      <form @submit.prevent="handleLogin">
        <input v-model="mail" type="mail" placeholder="Email" required /><br/><br/>
        <input v-model="password" type="password" placeholder="Password" required /><br/><br/>
        <button type="submit">Login</button><br/><br/><br/>
        <!-- <router-link to="/forgot-password">Forgot Password?</router-link><br/> -->
      </form>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from 'vue'
  import { useAuthStore } from '@/stores/authStore'
  import { useRouter } from 'vue-router'
  
  export default defineComponent({
    setup() {
      const mail = ref('')
      const password = ref('')
      const authStore = useAuthStore()
      const router = useRouter()
  
      const handleLogin = async () => {
        const credentials = { mail: mail.value, password: password.value }
        await authStore.login(credentials)
        if (authStore.isAuthenticated) {
          console.log("Authendicated successfully")
          router.push('/')
        }
        else
        {
          console.log("Please enter valid data")
        }
      }
  
      return {
        mail,
        password,
        handleLogin,
      }
    },
  })
  </script>

  <style scoped>

/* Center the Login Container */
.centered-div {
  background-color: white;     /* Background color for the div */
  padding: 30px;               /* Padding inside the div */
  border-radius: 8px;          /* Rounded corners */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Optional shadow for depth */
  width: 80%;                  /* Width of the div (you can adjust it) */
  max-width: 400px;            /* Maximum width to keep it from stretching too wide */
  text-align: center;          /* Center text inside the div */
  margin: auto;
}

/* Heading Styles */
h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

/* Input Fields */
input[type="mail"], input[type="password"] {
  width: 100%;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 14px;
}

input[type="mail"]:focus, input[type="password"]:focus {
  outline: none;
  border-color: #4CAF50;  /* Green border on focus */
}

/* Submit Button */
button[type="submit"] {
  width: 100%;
  padding: 12px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button[type="submit"]:hover {
  background-color: #45a049;
}

/* Forgot Password Link */
router-link {
  display: inline-block;
  margin-top: 15px;
  color: #2196f3;
  text-decoration: none;
  font-size: 14px;
}

router-link:hover {
  text-decoration: underline;
}

/* Mobile Responsiveness */
@media (max-width: 600px) {
  div {
    padding: 20px;
    width: 90%;  /* Make form take up more screen width on small devices */
  }

  input[type="mail"], input[type="password"], button[type="submit"] {
    font-size: 16px;  /* Make input fields and buttons more readable */
  }

  h2 {
    font-size: 20px;  /* Slightly smaller heading for mobile */
  }
}


</style>
  